<mat-nav-list>
  <a
    *ngFor="let link of links"
    mat-list-item
    [routerLink]="link.path"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: link.exact === true }"
    (click)="navAction.emit()"
    >{{ link.label }}</a
  >
  @if (isAuthenticated) {
    <button mat-list-item type="button" (click)="logout.emit(); navAction.emit()">Logout</button>
  }
</mat-nav-list>
